import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Departments from './components/Departments';
import Services from './components/Services';
import Doctors from './components/Doctors';
import DepartmentDetails from './components/DepartmentDetails';
import ServiceDetails from './components/ServiceDetails';
import Appointment from './components/Appointment';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Gallery from './components/Gallery';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Contact from './components/Contact';
import { useEffect, useState } from 'react';
import Login from './components/Login';
import { MessageProvider } from './context/MessageContext';
import ToastMessage from './components/ToastMessage';
import Register from './components/Register';
import Medicine from './components/Medicine';
import CartList from './components/CartList';
import OrderList from './components/OrderList';
import ThankYou from './components/ThankYou';
import ForgotPassword from './components/ForgotPassword';
import Profile from './components/Profile';
import ProfileUpdate from './components/ProfileUpdate';

function App() {
  const [mobileNav, setMobileNav] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("mobile-nav-active", mobileNav);
  }, [mobileNav]);

  // const location = useLocation();
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   setLoading(true);

  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, [location]);
  return (
    <>
      <MessageProvider>
        {/* {loading && (
          <div className="page-loader">
            <div className="spinner"></div>
          </div>
        )} */}
        <ToastMessage />
        <Header mobileNav={mobileNav} setMobileNav={setMobileNav} />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/services" element={<Services />} />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/medicine" element={<Medicine />} />
            <Route path="/department-details" element={<DepartmentDetails />} />
            <Route path="/service-details" element={<ServiceDetails />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/profile-update" element={<ProfileUpdate />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/cart" element={<CartList />} />
            <Route path="/order" element={<OrderList />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </main>
        <Footer />
      </MessageProvider>
    </>
  );
}

export default App;
